import writeXlsxFile from "write-excel-file"
import format from "date-fns/format"

export const GenerateAllInvoiceDownload = async (loads, assetLoads, invoices, invoicedLoads, jobName) => {
    const invName = `All Customer Invoices`
                    
    // replace periods from job name
    let newJobName = jobName.replace(/\./g, '-')
    // parse delivered date

    const ErrorHandler = (error) => {
        return (
            error.message
        )
    }
    
    const DeliveredOn = (d) => {
        try {
            return format(Date.parse(d), 'MM/dd/yy hh:m a')
        } catch (error) {
            return ErrorHandler(error)
        }
    }

    const getLoadInfo = (load_id, inv_id) => {
        let load = []
        const invoice = invoices.filter(x => x.id === inv_id)
        var inv
        var ld
        if (invoice.length > 0) {
            inv = invoice[0]
        } else {
            inv = {
                    invoice_name: '',
                    is_asset: false,
                }
        }
        if (inv.is_asset && assetLoads) {
            load = assetLoads.filter(x => x.id === load_id)
        } else {
            load = loads.filter(x => x.id === load_id)
        }
        if (load.length > 0 && invoice.length > 0) {
            ld = load[0]
        } else {
            ld = {
                freight_rev: 0,
                fsc_rev: 0,
                sand_rev: 0,
                weight_tons: 0,

            }
        }
        
        
        return {calcLoad: ld, invoice: inv}
    }
    const columns = [
        {width: 5},
        {width: 30},
        {width: 30},
        {width: 20},
        {width: 30},
        {width: 30},
        {width: 30},
        {width: 30},
        {width: 30},
        {width: 30},
        {width: 30},
        {width: 30},
        {width: 30},
        {width: 30},
        {width: 30},
        {width: 30},
        {width: 30},
            
    ]
    const blankRow = [{}]
    const data = [blankRow]
    
    const loadsHeader = [
        {},
        {
            value: 'Load No',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Is Asset Load',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Invoice Name',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Delivery Date',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Terminal',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Product',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'PO Number',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Ticket No',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Approved Mileage',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Weight (tons)',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Invoiced Weight (tons)',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Freight ($)',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Invoiced Freight ($)',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Fuel Surcharge ($)',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Invoiced Fuel Surcharge ($)',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Sand ($)',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Invoiced Sand ($)',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Total ($)',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Invoiced Total ($)',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        },
        {
            value: 'Difference ($)',
            fontWeight: 'bold',
            fontSize: 14,
            align: 'center'
        }
    ]
    data.push(loadsHeader)
    
    
    invoicedLoads.forEach(load => {
        let delivered = DeliveredOn(load.delivered_date)
        let {calcLoad, invoice} = getLoadInfo(load.load_id, load.invoice_id)
        if (calcLoad && invoice) {
            let tRev = 0
            if (invoice.is_asset) {
                tRev = calcLoad.freight_rev + calcLoad.fsc_rev
            } else {
                tRev = calcLoad.freight_rev + calcLoad.fsc_rev + calcLoad.sand_rev
            }
            let newLoad = [
                {},
                {
                    value: load.load_no,
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: (invoice.is_asset ? "X" : ""),
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: invoice.invoice_name,
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value:  delivered,
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: (invoice.is_asset ? "" : load.terminal_name),
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: (invoice.is_asset ? "" : load.product_name),
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: (invoice.is_asset ? "" : load.po_number),
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: (invoice.is_asset ? "" : load.ticket_number),
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: load.mileage,
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: calcLoad.weight_tons,
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: load.weight_tons,
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: calcLoad.freight_rev,
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: load.freight_rev,
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: calcLoad.fsc_rev,
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: load.fsc_rev,
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: (invoice.is_asset ? 0 : calcLoad.sand_rev),
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: load.sand_rev,
                    fontSize: 12,
                    align: 'center'
                },
                {
                    value: tRev,
                    fontSize: 12,
                    align: 'center'
                },                
                {
                    value: load.total_rev,
                    fontSize: 12,
                    align: 'center'
                },                
                {
                    value: Math.floor(load.total_rev - tRev),
                    fontSize: 12,
                    align: 'center'
                },                
            ]
            data.push(newLoad)
        }
        
    })
    await writeXlsxFile(data, {
        columns,
        fileName: `${newJobName} - ${invName}`
    })
}
    
